// extracted by mini-css-extract-plugin
module.exports = {"sprite-icon":"_18VJIg7MzLR5ULt5hnnXKS"};